<template>
  <li class="accordion__item">
    <div
      :class="[ 'accordion__item-question', { 'active': visible } ]"
      @click="open">
      <!-- This slot will handle the title/header of the accordion and is the part you click on -->
      <slot name="accordion-question"></slot>
      <span :class="{ 'active': visible }" class="icon-toggle icon--caret"></span>
    </div>

    <transition
      name="accordion"
      @enter="start"
      @after-enter="end"
      @before-leave="start"
      @after-leave="end">
      <div class="accordion__item-answer" v-show="visible">
        <!-- This slot will handle all the content that is passed to the accordion -->
        <slot name="accordion-answer"></slot>
      </div>
    </transition>
  </li>
</template>

<script>
export default {
  inject: [ 'Accordion' ],

  data () {
    return {
      index: null
    }
  },

  computed: {
    visible () {
      return this.index == this.Accordion.active
    }
  },

  created () {
    this.index = this.Accordion.count++
    if (this.index == 0) {
      this.Accordion.active = this.index
    }
  },

  methods: {
    open () {
      if (this.visible) {
        this.Accordion.active = null
      } else {
        this.Accordion.active = this.index
      }
    },
    start (el) {
      el.style.height = el.scrollHeight + 'px'
    },
    end (el) {
      el.style.height = ''
    }
  }
}
</script>
